module.exports = '/assets/bg.svg'